import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = [
    "closeButton",
    "searchInputWrapper",
    "searchInput",
    "searchExpandButton",
  ];

  static values = {
    autoSearch: Boolean,
    searchIsOpen: Boolean,
    expanded: Boolean,
  };

  connect() {
    this.boundHandleInput = this.handleInput.bind(this);
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    this.boundHandleKeyInput = this.handleKeyInput.bind(this);

    this.searchInputTarget.addEventListener("input", this.boundHandleInput);
    document.addEventListener("click", this.boundHandleClickOutside);
    this.searchInputTarget.addEventListener(
      "keydown",
      this.boundHandleKeyInput
    );
  }

  disconnect() {
    this.searchInputTarget.removeEventListener("input", this.boundHandleInput);
    document.removeEventListener("click", this.boundHandleClickOutside);
    this.searchInputTarget.removeEventListener(
      "keydown",
      this.boundHandleKeyInput
    );
  }

  close() {
    if (this.expandedValue) return;
    this.searchIsOpenValue = false;
    this.searchInputWrapperTarget.style.display = "none";
    this.searchExpandButtonTarget.style.removeProperty("display");
  }

  clearAndClose() {
    this.searchInputTarget.value = "";

    this.searchInputTarget.dispatchEvent(new Event("input", { bubbles: true }));

    if (this.autoSearchValue) {
      const form = this.searchInputTarget.form;
      form.requestSubmit();
    }

    this.close();
  }

  handleKeyInput(event) {
    if (event.key === "Escape") {
      this.clearAndClose();
    }

    if (event.key === "Enter") {
      event.preventDefault();
      const form = this.searchInputTarget.form;
      form.requestSubmit();
    }
  }

  handleClickOutside(event) {
    const isOutside =
      !this.searchInputWrapperTarget.contains(event.target) &&
      !this.searchExpandButtonTarget.contains(event.target);

    const isInputEmpty = this.searchInputTarget.value.trim() === "";

    if (isOutside && isInputEmpty) {
      this.close();
    }
  }

  handleInput(event) {
    if (this.autoSearchValue) {
      const value = event.target.value;
      const cursorPosition = event.target.selectionStart;

      if (value.length >= 3 || value.length === 0) {
        const form = this.searchInputTarget.form;
        form.requestSubmit();

        setTimeout(() => {
          this.searchInputTarget.focus();
          this.searchInputTarget.setSelectionRange(
            cursorPosition,
            cursorPosition
          );
        }, 0);
      }
    }
  }
  toggleExpand() {
    this.searchIsOpenValue = !this.searchIsOpenValue;

    this.searchInputWrapperTarget.style.removeProperty("display");
    this.searchExpandButtonTarget.style.display = "none";

    this.searchInputTarget.focus();
  }

  closeSearch() {
    if (this.searchIsOpenValue) {
      this.clearAndClose();
    }
  }
}
